import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  "pk_live_51NxQ3YFsqqjhURYglwSbG0d6qiwgknbNcLJZTQ1UDSYxT6LT8a0f6UefZm8k4gve6QpZ8U7KjvBuCjpSaukKsQBC00yP6GhTWe"
);
